// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vM-z","twoColumnImage":"wM-z"};